
import { defineComponent } from "vue";
import { useStore } from "vuex";
import SkillsSubPanel from "./SkillsSubPanel.vue";
import GenericPanel from "../shared/GenericPanel.vue";
import Checkbox from "../shared/Checkbox.vue";
import GenericButton from "../shared/GenericButton.vue";

export default defineComponent({
  name: "Skills",
  components: {
    SkillsSubPanel,
    GenericPanel,
    Checkbox,
    GenericButton,
  },

  setup() {
    const store = useStore();
    const showInfo = (category: string, stat: string) => {
      store.dispatch("handleIncomingCommand", {
        command: "updateInfoPanel",
        data: { category, stat },
      });
    };
    const selectSkill = (skill: string) => {
      store.dispatch("handleIncomingCommand", {
        command: "selectSkill",
        data: skill,
      });
    };
    return {
      state: store.state,
      Skills: store.state.build.Skills,
      showInfo,
      selectSkill,
    };
  },
});
